import axios from 'axios'
import { ALTERAR_CIDADE } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function cadastrarRota (cidade) {
  const url = `${URL}/cidades/alterar`;
  return dispatch => axios.post(url, cidade, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: ALTERAR_CIDADE,
        payload: response
      })
  );
}
